import { ResponseClientStatePasswordGet} from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ClientStatePasswordGetActions } from '../actions';
import { ClientStatePasswordGetTypes } from '../../shared/enums';

export interface ClientStatePasswordGetState {
    response: ResponseClientStatePasswordGet;
    request: null;
    error: any;
}

export const ClientStatePasswordGetInitialState: ClientStatePasswordGetState = {
    response: null,
    request: null,
    error: null
};

const _clientStatePasswordGetReducer = createReducer(
    ClientStatePasswordGetInitialState,

    on(ClientStatePasswordGetActions.getClientStatePasswordGet, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(ClientStatePasswordGetActions.getClientStatePasswordGetSuccess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ClientStatePasswordGetActions.getClientStatePasswordGetError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ClientStatePasswordGetActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function clientStatePasswordGetReducer(state, action) {
    if (action.type === ClientStatePasswordGetTypes.CLIENT_STATE_PASSWORD_GET) {
        state = undefined;
    }
    return _clientStatePasswordGetReducer(state, action);
}
